module.exports = __webpack_public_path__ + "img/pos1.c24bef09.jpg";